/**
 * Visual quiz-result summary used by both the student review (portal) and the
 * admin quiz detail. Mirrors the payment "stat tiles" treatment: a big score +
 * percentage, a segmented correct/wrong/skipped bar, and color-coded tiles.
 * Styles live in admin.css (loaded globally for both admin and portal).
 */
interface Break {
  chosen: string | null;
  isRight: boolean;
}

export default function QuizStats({
  breakdown,
  score,
  total,
}: {
  breakdown: Break[];
  score?: number;
  total?: number;
}) {
  const t = total ?? breakdown.length;
  const correct = breakdown.filter((b) => b.isRight).length;
  const answered = breakdown.filter((b) => b.chosen != null && b.chosen !== "").length;
  const wrong = answered - correct;
  const skipped = Math.max(0, t - answered);
  const pct = t ? Math.round((correct / t) * 100) : 0;
  const seg = (n: number) => (t ? `${(n / t) * 100}%` : "0%");

  return (
    <div className="quizsum">
      <div className="quizsum-score">
        <span className="big">{score ?? correct}</span>
        <span className="of">/ {t}</span>
        <span className="pct">{pct}%</span>
      </div>
      <div
        className="quizbar"
        role="img"
        aria-label={`${correct} correct, ${wrong} wrong, ${skipped} skipped of ${t}`}
      >
        {correct > 0 && <span className="c" style={{ width: seg(correct) }} />}
        {wrong > 0 && <span className="w" style={{ width: seg(wrong) }} />}
        {skipped > 0 && <span className="s" style={{ width: seg(skipped) }} />}
      </div>
      <div className="quizstats">
        <div className="qstat correct"><div className="lbl">Correct</div><div className="val">{correct}</div></div>
        <div className="qstat wrong"><div className="lbl">Wrong</div><div className="val">{wrong}</div></div>
        <div className="qstat skipped"><div className="lbl">Skipped</div><div className="val">{skipped}</div></div>
        <div className="qstat answered"><div className="lbl">Answered</div><div className="val">{answered}/{t}</div></div>
      </div>
    </div>
  );
}
